import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FormState {
  hasUnsavedChanges: boolean;
  showUnsavedChangesDialog: boolean;
  pendingNavigationRoute?: string | null;
}

const initialState: FormState = {
  hasUnsavedChanges: false,
  showUnsavedChangesDialog: false,
  pendingNavigationRoute: null,
};

export const formSlice = createSlice({
  name: 'unsavedChanges',
  initialState,
  reducers: {
    setHasUnsavedChanges(state, action: PayloadAction<boolean>) {
      state.hasUnsavedChanges = action.payload;
    },
    setShowUnsavedChangesDialog(state, action: PayloadAction<boolean>) {
      state.showUnsavedChangesDialog = action.payload;
    },
    resetHasUnsavedChanges(state) {
      state.hasUnsavedChanges = false;
      state.showUnsavedChangesDialog = false;
    },
    setPendingNavigationRoute(state, action: PayloadAction<string | null>) {
      state.pendingNavigationRoute = action.payload;
    },
  },
});

export const {
  setHasUnsavedChanges,
  setShowUnsavedChangesDialog,
  resetHasUnsavedChanges,
  setPendingNavigationRoute,
} = formSlice.actions;

export default formSlice.reducer;
